var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 3.42116L7.23376 9.7562C6.95971 10.0289 6.51651 10.0278 6.2438 9.75375C5.97112 9.47971 5.97221 9.03651 6.24626 8.7638L12.6414 2.4H9.995C9.60841 2.4 9.295 2.08659 9.295 1.7C9.295 1.31341 9.60841 1 9.995 1H13.04C14.1225 1 15 1.87752 15 2.96V6.005C15 6.39159 14.6866 6.705 14.3 6.705C13.9134 6.705 13.6 6.39159 13.6 6.005V3.42116ZM13.6 9.36957C13.6 8.98296 13.9134 8.66957 14.3 8.66957C14.6866 8.66957 15 8.98296 15 9.36957V13.04C15 14.1225 14.1225 15 13.04 15H2.96C1.87752 15 1 14.1225 1 13.04V2.96C1 1.87752 1.87752 1 2.96 1H6.63045C7.01702 1 7.33045 1.31341 7.33045 1.7C7.33045 2.08659 7.01702 2.4 6.63045 2.4H2.96C2.65072 2.4 2.4 2.65072 2.4 2.96V13.04C2.4 13.3493 2.65072 13.6 2.96 13.6H13.04C13.3493 13.6 13.6 13.3493 13.6 13.04V9.36955V9.36957Z",
    fill: "#97B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ac09ec8989a17b39777c90fcec1a7423.svg";
export { ForwardRef as ReactComponent };